import { Theme, Typography } from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';
import NumberFormat from 'react-number-format';
import { useQuoteState } from 'shared/contexts';

const clickStyles = (enableClick: boolean) => (theme: Theme) => ({
  cursor: enableClick ? 'pointer' : '',
});
interface NumberTextProps {
  text: string | number;
  suffix?: string;
  prefix?: string;
  variant?: Variant;
  decimalScale?: number;
  onClick?: () => void;
  fixedDecimalScale?: boolean;
}
export function NumberText({
  text,
  suffix,
  prefix,
  variant,
  decimalScale,
  onClick,
  fixedDecimalScale,
}: NumberTextProps) {
  const { editMode } = useQuoteState();
  return (
    <NumberFormat
      displayType='text'
      thousandSeparator={true}
      value={text}
      suffix={suffix}
      prefix={prefix}
      decimalScale={decimalScale}
      fixedDecimalScale={fixedDecimalScale}
      renderText={text => (
        <Typography sx={clickStyles(editMode && Boolean(onClick))} onClick={onClick} variant={variant}>
          {text}
        </Typography>
      )}
    />
  );
}
